package com.devi3east.bashbuddy.features.events.requests

import com.devi3east.bashbuddy.features.events.common.data.models.RaffleType
import com.devi3east.bashbuddy.features.events.common.data.models.TicketStatus
import com.devi3east.bashbuddy.features.events.common.data.models.TicketType
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class UpdateTicketRequest(
    val title: String? = null,
    val description: String? = null,
    val imageUrl: String? = null,
    val eventTitle: String? = null,
    val serialNumber: String? = null,
    val chancesPerTicket: Int? = null,
    val maxQuantity: Int? = null,
    val availableQuantity: Int? = null,
    val donation: Long,
    val shippingFee: Long = 0L,
    val ticketType: TicketType,
    val raffleType: RaffleType,
    val ticketStatus: TicketStatus? = null,
    val cutOffTimeInstant: Instant? = null,
    val isFiftyFifty: Boolean = false,
    val purchaseAge: Int? = null
)